import { render } from "./OnboardingStep4.vue?vue&type=template&id=7c046894"
import script from "./OnboardingStep4.vue?vue&type=script&lang=js"
export * from "./OnboardingStep4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__